import { render, staticRenderFns } from "./ProducerOldDebts.vue?vue&type=template&id=7efe1e92&scoped=true"
import script from "./ProducerOldDebts.vue?vue&type=script&lang=js"
export * from "./ProducerOldDebts.vue?vue&type=script&lang=js"
import style0 from "./ProducerOldDebts.vue?vue&type=style&index=0&id=7efe1e92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efe1e92",
  null
  
)

export default component.exports